<live-session-icon-svg />

@if(isBannerVisible && currentLiveSession) {
<div class="live-banner">
    <div class="live-desc">
        <button class="live-btn">
            <span>
                Join us LIVE!
            </span>
        </button>
        <div class="banner-line">
            |
        </div>
        <div class="event-info">
            <div class="event-icon">
                <svg>
                    <use xlink:href="#liveSessionIcon"></use>
                </svg>
            </div>
            <span>{{ currentLiveSession.title }}</span>
        </div>
        <button class="join-now-btn" (click)="joinLiveSession()">
            <svg>
                <use xlink:href="#bannerLiveIcon"></use>
            </svg>
            <span>Join Now</span>
        </button>
    </div>

    <button class="close-btn" (click)="closeLiveSolutionBanner()">
        <svg>
            <use xlink:href="#closeIcon"></use>
        </svg>
    </button>
</div>
}